import MedicationForm from './MedicationForm';

export default MedicationForm;
